/**
 * BottomNav — mobile sticky bottom tab bar.
 *
 * Only renders on (a) mobile viewports (sm and below) and (b) when the user
 * is authenticated. Five tabs: Home / Discover / Events / Messages / Profile.
 *
 * The active tab is auto-derived from the current route prefix.
 */
import { Link, useLocation } from 'react-router-dom';
import {
  Home, Compass, Calendar, MessageCircle, User as UserIcon,
} from 'lucide-react';

const TABS = [
  { id: 'home',     label: 'Home',     path: '/dashboard',           Icon: Home,          match: /^\/dashboard$/ },
  { id: 'discover', label: 'Discover', path: '/members',             Icon: Compass,       match: /^\/(members|investor-offers|businesses)/ },
  { id: 'events',   label: 'Events',   path: '/events',              Icon: Calendar,      match: /^\/events/ },
  { id: 'messages', label: 'DMs',      path: '/dashboard/messages',  Icon: MessageCircle, match: /^\/dashboard\/messages/ },
  { id: 'profile',  label: 'Profile',  path: '/dashboard/profile',   Icon: UserIcon,      match: /^\/dashboard\/(profile|settings|payments|subscription)/ },
];

const BottomNav = ({ user }) => {
  const { pathname } = useLocation();

  if (!user) return null;

  return (
    <nav
      data-testid="bottom-nav"
      className="sm:hidden fixed bottom-0 left-0 right-0 z-40 bg-slate-950/95 backdrop-blur border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="grid grid-cols-5">
        {TABS.map((t) => {
          const Icon = t.Icon;
          const active = t.match.test(pathname);
          return (
            <li key={t.id}>
              <Link
                to={t.path}
                data-testid={`bottom-nav-${t.id}`}
                className={`flex flex-col items-center gap-0.5 py-2 text-[10px] uppercase tracking-wider transition-colors ${
                  active ? 'text-[#d4af37]' : 'text-slate-400 hover:text-white'
                }`}
              >
                <Icon size={20} strokeWidth={active ? 2.5 : 1.8} />
                {t.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BottomNav;
